var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Subtraction_4","data-name":"Subtraction 4","d":"M21.43,20H2a2,2,0,0,1-2-2V6.361l9.916,5.846a3.538,3.538,0,0,0,3.595,0L23.43,6.36V18A2,2,0,0,1,21.43,20Zm-9.715-8.913h0a1.927,1.927,0,0,1-.978-.267L0,4.488V2A2,2,0,0,1,2,0H21.43a2,2,0,0,1,2,2v2.49L12.694,10.817A1.929,1.929,0,0,1,11.715,11.085Z","transform":"translate(-0.002 0.002)","fill":"#fafafa"}));
}

Mail.defaultProps = {"id":"Component_262_18","data-name":"Component 262 – 18","width":"23.428","height":"20","viewBox":"0 0 23.428 20"};

module.exports = Mail;

Mail.default = Mail;
